import React, { useEffect, useRef, useState } from "react";
import TextInput from "./TextInput";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { eventService } from "../services/EventService";
import { eventRegisterService } from "../services/EventRegisterService";
import { Toast } from "primereact/toast";
import ScreenLoader from "./ScreenLoader";
import { useContext } from "react";
import { AppDB } from "../App";
import { Dialog } from "primereact/dialog";

const EditRegister = ({ RefreshVoterRegister, showEditRegister, setshowEditRegister, selectedRegister, setSelectedRegister }) => {
	const { toast } = useContext(AppDB);
	const [isLoading, setLoading] = useState(false);
	const [form, setForm] = useState({
		name: selectedRegister?.name || "",
		description: selectedRegister?.description || "",
		certified: selectedRegister?.certified || false,
		eventID: selectedRegister?.eventID
	});
	useEffect(() => {
		setForm({
			name: selectedRegister?.name || "",
			description: selectedRegister?.description || "",
			certified: selectedRegister?.certified || false,
			eventID: selectedRegister?.eventID
		});
	}, [selectedRegister]);
	const handleSubmit = (e) => {
		e.preventDefault(); // Prevent default form submission behavior
		if (!form.name || !form.description) {
			alert("Please fill in all required fields.");
			return;
		}
		setLoading(true);
		setshowEditRegister(false);
		console.log(form);
		eventRegisterService
			.updateRegister(form, selectedRegister?.voterRegisterID)
			.then((res) => {
				if (res.success) {
					setLoading(false);
					RefreshVoterRegister();
					toast.show({
						severity: "success",
						detail: "Elector Register Updated",
						life: 2500
					});
				} else {
					setLoading(false);
					toast.show({
						severity: "error",
						detail: res.message,
						life: 2500
					});
				}
			})
			.catch((e) => {
				setLoading(false);
				return toast.currentshow({
					severity: "error",
					summary: "Error",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 2000
				});
			});
	};

	return (
		<Dialog
			draggable={true}
			header={
				<>
					<li className="pi pi-eye mr-1"> </li>
					<span> Edit Register</span>
				</>
			}
			visible={showEditRegister}
			style={{ width: "50%", height: "50%" }}
			modal
			onHide={(e) => {
				setshowEditRegister(false);
			}}
			footer={
                <>
                
                <Button className="p-button-danger" type="button" label="Close" onClick={() => setshowEditRegister(false)} />
                <Button className="p-button-success" type="button" label="Update" onClick={handleSubmit} />
                </>
            }
		>
            <ScreenLoader visible={isLoading} />
			<Toast ref={toast} />
			<form method="post">
				<div className="card mt-2 mb-1">
					<div className="grid py-2">
						<div className="col-12 lg:col-6">
							<TextInput label="Register Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
						</div>
						<div className="col-12 lg:col-6">
							<TextInput
								label="Register Description"
								value={form.description}
								onChange={(e) => setForm({ ...form, description: e.target.value })}
							/>
						</div>
						{selectedRegister?.certified && (
							<div className="col-12 lg:col-6">
								<label className="mr-2">Certified</label>
								<Checkbox inputId="Certified" checked={form.certified} onChange={(e) => setForm({ ...form, certified: e.checked })} />
							</div>
						)}
					</div>
				</div>
			</form>
		</Dialog>
	);
};

export default EditRegister;
